import { useState, useEffect } from 'react';

// The legacy V1 data hooks (useAtlasData + its error/polling scaffolding and
// a duplicate useLivePrices) were deleted 2026-08-15 — they had zero
// consumers since the V1 retirement (2026-07-12); the live price hook is
// src/v2/hooks/useLivePrices.js. Resurrect from git if ever needed.
// This left src/transforms/v2_to_data_shape.js test-only (npm run
// test:transforms), same kept-for-test status as src/search/scoring.js.

// ── MOBILE DETECTION ──────────────────────────────────────────────────────────
export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < 768 : false
  );
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return isMobile;
}
